import { isNull, isUndefined, omitBy } from 'lodash-es';

export const omitEmptyQueryParams = <T extends object>(obj: T): Partial<T> => {
  return omitBy(obj, val => isNull(val) || isUndefined(val));
};
